// src/services/socket.service.js
import { io } from 'socket.io-client';

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_API_URL?.replace('/api/v1', '') || 'http://localhost:8000';

let socket = null;

const socketService = {
  /**
   * Call this once after successful login.
   * Uses the same accessToken stored by auth.service.js
   */
  connect: () => {
    if (socket?.connected) return socket;

    const token = localStorage.getItem('accessToken');
    if (!token) {
      console.warn('[Socket] No access token — cannot connect');
      return null;
    }

    socket = io(SOCKET_URL, {
      path: '/socket.io',
      auth: { token },
      transports: ['websocket' , 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });

    socket.on('connect', () =>
      console.log('[Socket] ✅ Connected:', socket.id)
    );
    socket.on('disconnect', (reason) =>
      console.log('[Socket] ❌ Disconnected:', reason)
    );
    socket.on('connect_error', (err) =>
      console.error('[Socket] Connection error:', err.message)
    );

    return socket;
  },

  disconnect: () => {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  },

  getSocket: () => socket,

  isConnected: () => socket?.connected ?? false,
};

export default socketService;